//
//
//
//
//
//

export default {
    name: 'icon-svg',
    props: {
        name: {
            type: String,
            required: true
        },
        size:{
            type: [String, Number],
            default: ''
        },
        color:{
            type: String,
            default: ''
        }
    },
    computed: {
        iconName() {
            return `#sfe-icon-${this.name}`;
        },
        fontSize(){
            let fontSize = this.size;
            if(!isNaN(fontSize)){
                fontSize += 'px';
            }
            return fontSize;
        }
    }
};
